/**
 * Accordion Function
 *
 * Takes a wrapper element and a toggler. The toggler will find the parent
 * element and toggle an open css class. This is best used in a ul > li
 * scenario where the li.header is the toggler and subsequent li.list-items
 * are being toggled.
 *
 * Basic Example:
 *
 *   Script:
 *     accordion('.wrapper', '.toggler');
 *
 *   HTML:
 *   <div class="wrapper">
 *     <div class="item-1">
 *       <h3 class="toggler">Toggle this</h3>
 *       <div class="contents">Contents to be toggled</div>
 *     </div>
 *     <div class="item-2"> ... </div>
 *   </div>
 *
 * @param  {string} wrapper      the element which wraps the accordion function
 * @param  {string} toggler      the toggler element used to toggle parent element
 * @param  {bool}   firstOpen    whether to have the first accordion element open on load
 * @param  {bool}   closeSibling whether to close the sibling elements. Removes sibling open class
 * @return {void}
 */
export function accordion(wrapper, toggler, firstOpen = 1, closeSibling = 1) {
  const toggleList = [...document.querySelectorAll(`${wrapper} ${toggler}`)];

  if (toggleList) {
    toggleList.forEach((e, index) => {
      const parentToggler = e.parentElement;
      // Open the first element by default
      if (0 === index && firstOpen) {
        parentToggler.classList.add('open');
      }

      e.onclick = () => {
        parentToggler.classList.toggle('open');

        // close siblings
        if (closeSibling) {
          [...parentToggler.parentNode.children].forEach((child) => {
            if (child !== parentToggler && child.classList.contains('open')) {
              child.classList.remove('open');
            }
          });
        }
      };
    });
  }
}

export default accordion;
